module.exports = __webpack_public_path__ + "img/doc-empty-img1.418ffa17.png";